<template>
  <div class="flex justify-center mb-1">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseFilterGroup',
  props: {
    name: { type: String },
    filterName: { type: String, default: '' }
  },
  data () {
    return {
      selected: null
    }
  },
  methods: {
    switchItem (value) {
      if (this.selected === value) {
        this.selected = null
        this.$emit('filterChanged', this.name, undefined)
      } else {
        this.selected = value
        this.$emit(`filter${this.filterName}Changed`, this.name, value)
      }
    }
  }
}
</script>

<style scoped>

</style>
